export enum SupplyTypeEnum {
  golden_credit = 'GOLDEN_CREDIT',
  filling_station_credit = 'FILLING_STATION_CREDIT',
  driver_credit = 'DRIVER',
}
